export type ComponentBreakpoint = 'desktop' | 'tablet';

export const tableHeadMarginRequired = {
  marginRequiredDate: 'Data ',
  marginRequiredType: 'Requerido',
  marginWarranty: 'Em garantia',
  marginBalance: 'Saldo',
};

export const tableHeadPositionWarranty = {
  positionWarrantyType: 'Tipo',
  positionWarrantyAsset: 'Ativo',
  positionWarrantyQuantityDeposited: 'Qtd.depositada',
  positionWarrantyValue: 'Valor',
};

export const positionWarrantyWidthCols: Record<
  PositionWarrantyReportsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  positionWarrantyType: { desktop: 30, tablet: 30 },
  positionWarrantyAsset: { desktop: 30, tablet: 30 },
  positionWarrantyQuantityDeposited: { desktop: 30, tablet: 30 },
  positionWarrantyValue: { desktop: 10, tablet: 10 },
};

export const marginRequiredWidthCols: Record<
  MarginRequiredReportsRecords,
  { [K in ComponentBreakpoint]: number }
> = {
  marginRequiredDate: { desktop: 30, tablet: 30 },
  marginRequiredType: { desktop: 30, tablet: 30 },
  marginWarranty: { desktop: 30, tablet: 30 },
  marginBalance: { desktop: 10, tablet: 10 },
};

type MarginRequiredReportsRecords = keyof typeof tableHeadMarginRequired;
type PositionWarrantyReportsRecords = keyof typeof tableHeadPositionWarranty;

export const tableHeadAlignments: Partial<
  Record<MarginRequiredReportsRecords | PositionWarrantyReportsRecords, 'left' | 'center' | 'right'>
> = {};
